// ─────────────────────────────────────────────
// KLOTHIQ — Page Header Component (Premium Dark)
// ─────────────────────────────────────────────

import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import type { ReactNode } from 'react';
import UserGuide from '@/components/help/UserGuide';

interface PageHeaderProps {
  title: string;
  description?: string;
  backTo?: string;
  actions?: ReactNode;
}

export default function PageHeader({ title, description, backTo, actions }: PageHeaderProps) {
  const navigate = useNavigate();

  return (
    <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
      <div className="flex min-w-0 items-start gap-3">
        {backTo && (
          <button
            onClick={() => navigate(backTo)}
            className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-border bg-card text-muted-foreground transition-colors hover:border-primary hover:bg-accent hover:text-primary"
            aria-label="Go back"
          >
            <ArrowLeft className="h-5 w-5" />
          </button>
        )}
        <div className="min-w-0">
          <h1 className="break-words text-xl font-bold tracking-tight text-foreground sm:text-2xl">
            {title}
          </h1>
          {description && <p className="mt-0.5 text-sm text-muted-foreground">{description}</p>}
        </div>
      </div>
      <div className="flex max-w-full shrink-0 flex-wrap items-center gap-2">
        <UserGuide />
        {actions}
      </div>
    </div>
  );
}
